package uz.ferro.erp.feature.order.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.api.suspendPost
import uz.ferro.erp.api.suspendPut
import uz.ferro.erp.feature.order.model.Order
import uz.ferro.erp.feature.order.model.OrderPaymentInfo
import uz.ferro.erp.feature.order.model.Usage
import uz.ferro.erp.feature.product.model.Product
import uz.ferro.erp.util.generateUUID

object OrderRepository {

    private const val API_PATH = "order"
    private const val API_GET = "$API_PATH/{id}"
    private const val API_REQUEST_ORDER = "$API_PATH/request"
    private const val API_ORDER_LIST = "$API_PATH/list"
    private const val API_ORDER_RESERVE = "$API_PATH/{id}/reserve"
    private const val API_PAYMENT_INFO = "$API_PATH/{id}/payment-info"
    private const val API_ORDER_USAGE = "$API_PATH/{id}/usage"

    suspend fun orderProduct(
        product: Product
    ): Order {
        val body = Order(
            uuid = generateUUID(),
            deviceId = "test",
            product = product
        )

        val result: Order = suspendPost(path = API_REQUEST_ORDER, body = body)
        return result
    }

    suspend fun reserveOrder(id: Long): Order {
        return suspendPut(API_ORDER_RESERVE.id(id))
    }

    suspend fun getPaymentInfo(id: Long): OrderPaymentInfo {
        return suspendGet(API_PAYMENT_INFO.id(id))
    }

    suspend fun getOrders(): List<Order> {
        return suspendGet(API_ORDER_LIST)
    }

    suspend fun getOrder(id: Long): Order {
        return suspendGet(API_GET.id(id))
    }

    suspend fun getUsage(id: Long): Usage? {
        return try {
            suspendGet(API_ORDER_USAGE.id(id))
        } catch (e: Exception) {
            null
        }
    }

    private fun String.id(id: Long): String {
        return pathParam("id", id)
    }

    private fun String.pathParam(paramName: String, value: Any): String {
        return replace("{$paramName}", value.toString())
    }
}